<template>
  <span
    class="rte-resizable-image"
    :class="{ 'rte-resizable-image--selected': selected }"
    :style="wrapperStyle"
    data-drag-handle
    @mousedown="onSelect"
  >
    <img :src="node.attrs.src" :alt="node.attrs.alt || ''" :title="node.attrs.title || ''" draggable="false" />
    <span
      v-if="selected && view.editable"
      class="rte-resizable-image__handle"
      contenteditable="false"
      @mousedown.stop.prevent="startResize"
    ></span>
    <div v-if="selected && view.editable" class="rte-resizable-image__sizes" contenteditable="false">
      <button type="button" class="rte-resizable-image__size-btn" @mousedown.prevent @click.stop="setWidth('100%')">
        100%
      </button>
      <button type="button" class="rte-resizable-image__size-btn" @mousedown.prevent @click.stop="setWidth('50%')">
        50%
      </button>
      <button type="button" class="rte-resizable-image__size-btn" @mousedown.prevent @click.stop="setWidth('33%')">
        33%
      </button>
      <button type="button" class="rte-resizable-image__size-btn" @mousedown.prevent @click.stop="setWidth('25%')">
        25%
      </button>
    </div>
  </span>
</template>

<script>
export default {
  props: ["node", "updateAttrs", "view", "selected", "getPos"],
  computed: {
    wrapperStyle() {
      const width = this.node.attrs.width || "100%";
      return {
        width,
        maxWidth: "100%",
      };
    },
  },
  methods: {
    onSelect() {
      // TipTap selects the node via ProseMirror; keep default behavior.
    },
    setWidth(width) {
      this.updateAttrs({ width });
    },
    startResize(event) {
      const startX = event.clientX;
      const parent = this.$el.parentElement;
      const parentWidth = parent ? parent.clientWidth : 600;
      const startWidthPx = this.$el.getBoundingClientRect().width;

      const onMove = (moveEvent) => {
        const delta = moveEvent.clientX - startX;
        const nextPx = Math.max(48, Math.min(parentWidth, startWidthPx + delta));
        const percent = Math.round((nextPx / parentWidth) * 100);
        this.updateAttrs({ width: `${Math.max(10, Math.min(100, percent))}%` });
      };

      const onUp = () => {
        window.removeEventListener("mousemove", onMove);
        window.removeEventListener("mouseup", onUp);
      };

      window.addEventListener("mousemove", onMove);
      window.addEventListener("mouseup", onUp);
    },
  },
};
</script>

<style lang="scss">
.rte-resizable-image {
  position: relative;
  display: inline-block;
  vertical-align: top;
  line-height: 0;
  margin: 4px 6px 4px 0;
  max-width: 100%;
  box-sizing: border-box;

  img {
    display: block;
    width: 100%;
    height: auto;
    max-width: 100%;
    object-fit: contain;
  }

  &--selected {
    outline: 2px solid #1976d2;
    outline-offset: 2px;
  }
}

.rte-resizable-image__handle {
  position: absolute;
  right: -5px;
  bottom: -5px;
  width: 12px;
  height: 12px;
  background: #1976d2;
  border: 2px solid #fff;
  border-radius: 2px;
  cursor: nwse-resize;
  z-index: 2;
}

.rte-resizable-image__sizes {
  position: absolute;
  left: 0;
  top: -28px;
  display: flex;
  gap: 4px;
  z-index: 3;
}

.rte-resizable-image__size-btn {
  border: 1px solid #cfcfcf;
  background: #fff;
  color: #333;
  font-size: 10px;
  line-height: 1;
  padding: 4px 6px;
  border-radius: 2px;
  cursor: pointer;

  &:hover {
    background: #f5f5f5;
  }
}
</style>
